import { Region } from '../region';
import { IPaymentProvider } from '../../providers/payment/payment.interface'
import { PaymentProviderCyberSource } from '../../providers/payment/payment.cybersource'
import { DirectBankBrand } from '../../model/types/payment-method-type';


/**
 * @description Geographical region the application is currently configured for, e.g. US, Spain, Australia.
 * @region Enumeration for this region.
 * @defaultCountryFrom Default value to use for send-from country, i.e. in price calculator
 * @defaultCurrencyFrom Default value to use for send-from currency, i.e. in price calculator
 * @defaultLanguage Default language culture to use, i.e. content translations
 */

export const regionValues = {

  region: Region.SN,
  regionId: 10311,
  defaultCountryFrom: 'SN',
  defaultCountryFromOnfido: 'SEN',
  defaultAmountFrom: 100,
  defaultCountryCodeFrom: 221,
  defaultCurrencyFrom: 'XOF',
  defaultLanguageCulture: 'en-SN',
  defaultLocation: {
    latitude: -10.752170,
    longitude: 27.248020
  },
  dateFormat: 'DD/MM/YYYY',  
  postalCodeRegex:`^\\d{5}$`,
  links: {
    linkFaq: 'https://www.riamoneytransfer.com/us/en/mobile-content/faqs'
  },
  languageCultures: ['fr-SN', 'en-SN'],
  regionalIp: '66.82.123.234',
  paymentProvider: <IPaymentProvider>new PaymentProviderCyberSource(),
  isPlaidEnabled: false,
  isBankAccountEnabled:false,
  useSecurityQuestions: false,
  oldRemittanceLogin: false,
  onfidoMaxAttempts: 0,
  directBankBrand: DirectBankBrand.FPX,
  distanceMetric: 'km',
  acceptInternationalCards:false,
  stagedRiaBrand: '',
  payNearMeBrand: '',
  isEu: false,
  isEMEA: false,
  notShowMarketingPushAlert: true,
  useVeriff: false,
  walletSettings:{
    isMerchantSupportEnable: false,
  },
  defaultTranslationParams: null,
  originalCountryAllowedOnly: true,
  riaPrepaidCardBinNumber: "53478085",
  canShowLogosOnQRScanner: false,
  airtimeServices:{
    isAirTimeSevice:true,
    isLocalOnly:true,
  },
  passCodeLength: 4,
  showNewHomePage: false,
  googlepayAdyenPaymentNetworks: [],
  applepayAdyenPaymentNetworks: [],
  adyenMerchantCapability: [],
  walletServices:[
    {
      type: "receive",
      icon: "../../assets/img/wallet/receive.svg",
      title: "page:walletHomepage:convertPINButton",
      sortOrder: 1,
    }, {
      type: "send",
      icon: "../../assets/img/wallet/send.svg",
      title: "page.myRecipientsPage.eWalletSendButton",
      sortOrder: 2,
      canShowOptions: true,
      options:[
        {
          type: "wallet",
          title:"page.eWalletPage.sendMoneyOptionsWallet",
          subTitle: "",
          image: "assets/icons/wallet-tab-more.svg",
          sortOrder: 1,
        }, {
          type: "sendmoney",
          title:"page.eWalletPage.sendMoneyOptionsTransfer",
          subTitle: "page.eWalletPage.sendMoneyOptionsTransferText",
          image: "assets/icons/global-smf-gray.svg",
          sortOrder: 2,
        }
      ]
    }, {
      type: "billpayments",
      icon: "../../assets/img/wallet/billpayments.svg",
      title: "page.eWalletPage.activityPage.billPayLabel",
      sortOrder: 3,
    }, {
      type: "airtime",
      icon: "../../assets/img/wallet/airtime.svg",
      title: "page.topUpPage.airtimeLabel",
      sortOrder: 4
    }
  ],
  isCountrySupportDecimal: false,
  autoEnableMarketingPreference: false,
  loginRootHomePage: "wallethome",
  adyenRegion: ''
};


// WEBPACK FOOTER //
// ./src/environment/region/SN.ts